import React from 'react'
import { MAPPED_OR_TRANSFERRED_ATTRIBUTE_VALUES, UNIQUE_ATTRIBUTE_VALUES, VIEW_ALL } from '../utils/Constants';
import arrowIcon from "assests/img/right-arrow-icon.svg";

type UniqueAttributeValuesProps = {
    payload: TRecategorizePayload;
    attributeValues: AttributeValue[];
    setAttributeValueData: React.Dispatch<React.SetStateAction<AttributeValueMapping | null>>;
    sourceAttributeId: string;
    targetAttributeId: string;
}
const UniqueAttributeValues = ({ payload, attributeValues, sourceAttributeId, targetAttributeId, setAttributeValueData }: UniqueAttributeValuesProps) => {
    const handleViewAll = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {

        e.stopPropagation();
        setAttributeValueData({
            selectedSourceAttribute: sourceAttributeId,
            selectedTargetAttribute: targetAttributeId,
            showAttributeValuesMapping: true,
            attributeValuesCount: attributeValues.length,
            payload: payload
        });
    }
    const mappedOrCreatedCount = attributeValues.filter(value => {
        const uniqueValue = payload.unique_attr_source_list
            .find(attr => attr.attribute_id === sourceAttributeId)
            ?.unique_attribute_values
            ?.find(val => val.attribute_value === value.value);

        return uniqueValue?.action === 'map' && uniqueValue.target_attribute_value || uniqueValue?.action === 'create';
    }).length;

    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <div className="tw-flex tw-items-center">
                <div>{UNIQUE_ATTRIBUTE_VALUES}</div>
            </div>

            <div className="tw-flex tw-items-center tw-gap-4">
                <span className="tw-text-[#172b4d] tw-text-sm tw-font-medium">{attributeValues.length} Attributes values found</span>
                <button disabled={attributeValues?.length <= 0} onClick={(e) => { if (attributeValues?.length > 0) handleViewAll(e) }} className="outline-button tw-w-[120px] tw-h-[30px] tw-px-2.5 tw-py-2 tw-bg-[#f4f5f7] tw-rounded tw-border tw-border-[#0747a6] tw-flex tw-items-center tw-gap-2.5">
                    <span className="tw-w-20 tw-text-[#0747a6] tw-text-xs tw-font-normal tw-font-[Noto Sans] tw-leading-tight">
                        {VIEW_ALL}
                    </span>
                    <img
                        src={arrowIcon}
                        alt=""
                        className="tw-w-4 tw-h-4"
                    />
                </button>
            </div>

            <div className="tw-flex tw-items-center tw-gap-4">
                <span>{MAPPED_OR_TRANSFERRED_ATTRIBUTE_VALUES}</span>
                <div className="tw-bg-gray-100 tw-px-3 tw-py-1 tw-rounded">
                    {mappedOrCreatedCount} / {attributeValues.length}
                </div>
            </div>
        </div>
    );
}

export default UniqueAttributeValues